import React from 'react';
import { FaRegCopyright } from 'react-icons/fa';


export default function Footer(){
    return(
        <>
        <p style={{background:"#222222ef",color:"white",textAlign:"center",padding:"10px 0"}}>
            Copyright <FaRegCopyright style={{marginBottom:"-2px"}}/> 2022-2023 Dox&Box.All right.reserved
        </p>
        </>
    )
} 